import { useParams } from 'react-router-dom';
import { SymbolPageStep } from './hooks';
import { useDomesticRealEstateItExplanationSymbolPage } from './hooks'
import { LoadingContainer, LoadingSize } from 'views/mutual/loading';
import { DomesticRealEstateItExplanationSymbolDetail } from './symbolDetail';
import { DomesticRealEstateItExplanationSymbolApplyConfirm } from './symbolApplyConfirm';
import { DomesticRealEstateItExplanationSymbolApplyComplete } from './symbolApplyComplete';
import { useEffect } from 'react';
import { NotFoundData } from 'views/mutual/notFoundData';
import { CompatibilityCheck } from 'views/pages/compatibilityCheck';
import { ProductType } from 'constants/productType';
import { ApplicationStatusWrapper } from '../../module/applicationStatus';
import { DomesticRealEstateItExplanationSymbolApplyImpossible } from './symbolApplyImpossible';

export const DomesticRealEstateItExplanationSymbol = () => {
  const { symbol } = useParams<{ symbol: string }>();

  const {
    symbolPageStep,
    symbolDetailInfo,
    formik,
    canApplyItExplanation,
    backDetailPage,
    lotInputControlProps,
    modalProps,
  } = useDomesticRealEstateItExplanationSymbolPage({ symbol: symbol! });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [symbolPageStep]);

  if (symbolDetailInfo.fetching) {
    return (
      <LoadingContainer isLoading={symbolDetailInfo.fetching} size={LoadingSize.Medium}>
        <div></div>
      </LoadingContainer>
    );
  } else {
    if (!symbolDetailInfo.data?.GetDomesticRealEstateSymbolInfo) {
      return (
        <NotFoundData
          backPageType={{
            kind: 'previous',
          }}
        />
      );
    }

    switch (symbolPageStep) {
      case SymbolPageStep.Detail:
        return (
          <DomesticRealEstateItExplanationSymbolDetail
            symbolDetail={symbolDetailInfo.data?.GetDomesticRealEstateSymbolInfo}
            formik={formik}
            canApplyItExplanation={canApplyItExplanation}
            lotInputControlProps={lotInputControlProps}
            modalProps={modalProps}
          />
        );
      case SymbolPageStep.CompatibilityCheck:
        return (
          <CompatibilityCheck
            assetType={ProductType.DomesticRealEstate}
            completedNextPage={{
              label: '電子交付・IT重説の申込みに進む',
              navigate: formik.handleSubmit,
            }}
          />
        );
      case SymbolPageStep.ApplicationStatus:
        return (
          <ApplicationStatusWrapper 
            assetType={ProductType.DomesticRealEstate}
            navigate={formik.handleSubmit}
            initializeFlags={{
              initializeHasDividendAccountFlag: true,
              initializeHasValidInvoiceNumberAnswerFlag: true,
              initializeHasValidFatcaAnswerFlag: true,
            }}
          />
        );
      case SymbolPageStep.Confirm:
        return (
          <DomesticRealEstateItExplanationSymbolApplyConfirm
            symbolDetail={symbolDetailInfo.data?.GetDomesticRealEstateSymbolInfo}
            formik={formik}
            backDetailPage={backDetailPage}
          />
        );
      case SymbolPageStep.Complete:
        return (
          <DomesticRealEstateItExplanationSymbolApplyComplete
            symbolDetail={symbolDetailInfo.data?.GetDomesticRealEstateSymbolInfo}
            formik={formik}
            backDetailPage={backDetailPage}/>
        );
      case SymbolPageStep.Error:
        return (
          <DomesticRealEstateItExplanationSymbolApplyImpossible
            symbolDetail={symbolDetailInfo.data?.GetDomesticRealEstateSymbolInfo!}/>
        );
      }
  }
};